import { getField, updateField } from 'vuex-map-fields';

const state = {
    cita: {}
};

const mutations = {
    updateField,
    updateCita: (state, payload) => {
        state.cita = payload;
    },
};
const getters = {
    getField,
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
